import { CompanyFormState } from "company/detail/components/models";
import PhoneRow from "components/DetailPage/PhoneRow";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import { convertToPhoneNumbers } from "components/PhoneInput";
import WebsiteLink from "components/Website/WebsiteLink";
import React from "react";
import { newLineToBr } from "utilities";
import { isNullOrEmptyString } from "shared/utils";

export const contactDetailsSection = (
  existingCompany: CompanyFormState,
  sourceCompany: CompanyFormState,
  currentCompany: CompanyFormState,
  setCurrentCompany: (company: CompanyFormState) => void
): MergeFormSection => ({
  key: "contactDetails",
  title: RESX.Contact.ContactDetails,
  fields: [{
    key: "phone",
    label: RESX.ContactDetails.PhoneNumber,
    currentValue: currentCompany.phone,
    existingValue: existingCompany.phone,
    sourceValue: sourceCompany.phone,
    isEmpty: (v) => isNullOrEmptyString(v),
    render: (v) => <PhoneRow numbers={convertToPhoneNumbers(v)} />,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      phone: sourceCompany.phone,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      phone: existingCompany.phone,
    }),
  }, {
    key: "website",
    label: RESX.GeneralLabels.Website,
    currentValue: currentCompany.website,
    existingValue: existingCompany.website,
    sourceValue: sourceCompany.website,
    isEmpty: (v) => !v,
    render: (v) => <WebsiteLink website={v} />,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      website: sourceCompany.website,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      website: existingCompany.website,
    }),
  }, {
    key: "facebook",
    label: "Facebook",
    currentValue: currentCompany.facebook,
    existingValue: existingCompany.facebook,
    sourceValue: sourceCompany.facebook,
    isEmpty: (v) => !v,
    render: (v) => <WebsiteLink website={v} />,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      facebook: sourceCompany.facebook,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      facebook: existingCompany.facebook,
    }),
  }, {
    key: "networkPath",
    label: RESX.Company.NetworkPath,
    currentValue: currentCompany.networkPath,
    existingValue: existingCompany.networkPath,
    sourceValue: sourceCompany.networkPath,
    isEmpty: (v) => !v,
    render: (v) => <WebsiteLink website={v} />,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      networkPath: sourceCompany.networkPath,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      networkPath: existingCompany.networkPath,
    }),
  }, {
    key: "additional",
    label: RESX.Company.AdditionalInformation,
    currentValue: currentCompany.additional,
    existingValue: existingCompany.additional,
    sourceValue: sourceCompany.additional,
    isEmpty: (v) => !v,
    render: (v) => <span>{newLineToBr(v)}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      additional: sourceCompany.additional,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      additional: existingCompany.additional,
    }),
  }]
})